var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "yxtbiz-ote-quespoint-selector" },
        [
          _c(
            "yxt-select",
            {
              class: _vm.selectClass,
              attrs: {
                disabled: _vm.disabled,
                "allow-create": false,
                multiple: _vm.multipleLimit > 1,
                size: _vm.selectSize,
                clearable: "",
                placeholder: _vm.$t("pc_biz_ote_lbl_pleaseselect2"),
                "multiple-limit": _vm.multipleLimit,
              },
              model: {
                value: _vm.selectedPoints,
                callback: function ($$v) {
                  _vm.selectedPoints = $$v
                },
                expression: "selectedPoints",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c(
                "yxt-option",
                {
                  key: item.value,
                  attrs: {
                    "multiple-limit": _vm.multipleLimit,
                    label: item.label,
                    value: item.value,
                  },
                },
                [
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        content: item.label,
                        "open-filter": "",
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "d-in-block max-width292 ellipsis" },
                        [_vm._v(_vm._s(item.label))]
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }